import styled from 'styled-components';

export const Wrapper = styled.div`
    flex: 1;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    gap: 8px;
`;

export const Content = styled.div`
    background-color: rgba(0, 0, 0, 0.03);
    padding: 10px;
`;

export const Field = styled.div`
    margin-top: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
`;

export const Label = styled.div`
    flex-basis: 70px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
